// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"8dae1407","498":"db12675c","703":"0b847fb2","787":"74613da2"}[chunkId] + ".chunk.js";
};